import React, { useEffect, useRef } from "react";
import { globalLightboxStyle, useHandleClickOutside } from "oolib";
import styled from 'styled-components';

const StyledPopoverWrapper = styled.div`
  position: relative;
`;

const StyledPopover = styled.div`
  position: absolute;
  top: calc(100% + 0.8rem);
  right: 0;
  min-width: ${({ minWidth }) => minWidth || '300px'};
  max-width: ${({ maxWidth }) => maxWidth || 'none'};
  z-index: ${({ zIndex }) => zIndex || 1000};
  ${globalLightboxStyle}
  border-radius: 6px;
`;

export const PopoverMenu = ({ 
  children, 
  trigger, 
  isOpen, 
  onClose, 
  minWidth, 
  maxWidth, 
  zIndex,
  position = 'right', // 'left' | 'right' | 'center'
  offset = '0.8rem',
  closeOnClickOutside = true,
  closeOnEscape = true,
  className,
  popoverClassName
}) => {
  const popoverRef = useRef(null);

  useHandleClickOutside(popoverRef, () => onClose?.(), { 
    enabled: closeOnClickOutside && isOpen 
  });

  // Handle escape key to close popover
  useEffect(() => {
    if (!closeOnEscape || !isOpen) return;

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose?.();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, closeOnEscape, onClose]);

  const getPositionStyles = () => {
    const baseStyles = {
      top: `calc(100% + ${offset})`,
      minWidth,
      maxWidth,
      zIndex
    };

    switch (position) {
      case 'left':
        return { ...baseStyles, left: 0 };
      case 'center':
        return { ...baseStyles, left: '50%', transform: 'translateX(-50%)' };
      case 'right':
      default:
        return { ...baseStyles, right: 0 };
    }
  };

  return (
    <StyledPopoverWrapper ref={popoverRef} className={className}>
      {trigger}
      
      {isOpen && (
        <StyledPopover 
          style={getPositionStyles()}
          className={popoverClassName}
        >
          {children}
        </StyledPopover>
      )}
    </StyledPopoverWrapper>
  );
};
